import Spin from '@widesk-ui/components/Spin';

const PendingMark = () => (
	<span
		aria-hidden
		style={{
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexShrink: 0,
			width: 24,
			height: 24,
		}}
	>
		<Spin size="small" />
	</span>
);

export default PendingMark;
